import request from "@/utils/request";
//查询首页轮播图配置
function getColumnListConfig(bannerType, selectChannel) {
    return request({
        url: `/app/banner/getBannerList?bannerType=${bannerType}&selectChannel=${selectChannel}`,
        method: "get",
    });
}

//查询首页配置
function publicListConfig(keyword) {
    return request({
        url: `/app/productArea/getDisplayAreaProducts`,
        method: "get",
    });
}

//查询科研服务
function getMessageConfig() {
    return request({
        url: `/app/researchManage/query`,
        method: "get",
    });
}

//产品搜索
function treeCatalogueSelectConfig(data) {
    // return request({
    //     url: `/app/product/searchProductList?pageNum=${list.pageNum}&pageSize=${list.pageSize}&keyword=${list.keyword}`,
    //     method: "get",
    // });
    return request({
        url: `/app/product/searchProductList`,
        method: "POST",
        data
    });
}

//产品浏览记录
function productLookedRecordConfig(list) {
    return request({
        url: `/app/productLookedRecord/page?pageNum=${list.pageNum}&pageSize=${list.pageSize}`,
        method: "get",
    });
}

function loginConfig(data) {
    return request({
        url: `/app/customer/login`,
        method: "POST",
        data
    });
}

//会员
function registerConfig(data) {
    return request({
        url: `/app/customer/register`,
        method: "POST",
        data
    });
}

//产品详情
function detailConfig(id) {
    return request({
        url: `/app/product/detail?id=${id}`,
        method: "get",
    });
}

//添加商品到购物车
function addToCartConfig(data) {
    return request({
        url: `/app/cartItem/addToCart`,
        method: "POST",
        data
    });
}

//购物车列表页
function getUserCartConfig() {
    return request({
        url: `/app/cartItem/getUserCart`,
        method: "get",
    });
}

//删除购物车列表页
function deleteCartItemsConfig(data) {
    return request({
        url: `/app/cartItem/deleteCartItems`,
        method: "POST",
        data: {
            cartItemsIds: data
        }
    });
}

//更新购物车商品数量
function updateCartItemsConfig(data) {
    return request({
        url: `/app/cartItem/updateCartItems`,
        method: "POST",
        data
    });
}

//创建订单-从购物车下单
function createOrderFromCartConfig(data) {
    return request({
        url: `/app/order/createOrderFromCart`,
        method: "POST",
        data
    });
}

//创建订单-从购物车下单
function createOrderFromProductConfig(data) {
    return request({
        url: `/app/order/createOrderFromProduct`,
        method: "POST",
        data
    });
}

//产品浏览记录
function queryUserOrderListConfig(list) {
    return request({
        url: `/app/order/queryUserOrderList?pageNum=${list.pageNum}&pageSize=${list.pageSize}&orderStatus=${list.orderStatus}`,
        method: "get",
    });
}

//查询用户的地址列表
function queryUserShippingListConfig() {
    return request({
        url: `/app/shippingInfo/queryUserShippingList`,
        method: "get",
    });
}

//地址添加
function shippingInfoConfig(data) {
    return request({
        url: `/app/shippingInfo/add`,
        method: "POST",
        data
    });
}

//地址详情
function shippingInfodetailConfig(id) {
    return request({
        url: `/app/shippingInfo/detail?id=${id}`,
        method: "get",
    });
}

//地址修改
function shippingInfoupdateConfig(data) {
    return request({
        url: `/app/shippingInfo/update`,
        method: "POST",
        data
    });
}

//地址删除
function shippingInfodeleteConfig(data) {
    return request({
        url: `/app/shippingInfo/delete`,
        method: "POST",
        data
    });
}

//订单准备支付（拉起支付）
function orderPrePayConfig(data) {
    return request({
        url: `/app/order/orderPrePay`,
        method: "POST",
        data
    });
}

//用户删除订单
function deleteOrderConfig(data) {
    return request({
        url: `/app/order/deleteOrder`,
        method: "POST",
        data
    });
}

//查询订单详情
function queryOrderDetailConfig(id) {
    return request({
        url: `/app/order/queryOrderDetail?orderNo=${id}`,
        method: "get",
    });
}

//用户取消订单
function cancelOrderConfig(data) {
    return request({
        url: `/app/order/cancelOrder`,
        method: "POST",
        data
    });
}

//订单确认收货
function confirmConfig(data) {
    return request({
        url: `/app/order/confirm`,
        method: "POST",
        data
    });
}

//查询订单状态
function queryOrderStatusConfig(id) {
    return request({
        url: `/app/order/queryOrderStatus?orderNo=${id}`,
        method: "get",
    });
}

//再次购买到购物车
function batchAddToCartConfig(data) {
    return request({
        url: `/app/cartItem/batchAddToCart`,
        method: "POST",
        data
    });
}

//查询用户信息
function queryUserConfig(id) {
    return request({
        url: `/app/customer/queryUser?phone=${id}`,
        method: "get",
    });
}

//统计用户订单数量
function getUserOrderStatusCountConfig() {
    return request({
        url: `/app/order/getUserOrderStatusCount`,
        method: "get",
    });
}

//再次购买到购物车
function updateEmailConfig(data) {
    return request({
        url: `/app/customer/updateEmail`,
        method: "POST",
        data
    });
}

//再次购买到购物车
function modifyPasswordConfig(data) {
    return request({
        url: `/app/customer/modifyPassword`,
        method: "POST",
        data
    });
}

//重置密码
function resetPasswordConfig(data) {
    return request({
        url: `/app/customer/resetPassword`,
        method: "POST",
        data
    });
}

//发送短信验证码
function sendSmsCodeConfig(data) {
    return request({
        url: `/app/customer/sendSmsCode`,
        method: "POST",
        data
    });
}
//上传图片
function uploadConfig(formData) {
    return request({
        url: `/app/file/upload`,
        method: "POST",
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}

//用户上传支付凭证
function uploadVoucherConfig(data) {
    return request({
        url: `/app/order/uploadVoucher`,
        method: "POST",
        data
    });
}


export { uploadVoucherConfig,uploadConfig, getColumnListConfig, publicListConfig, getMessageConfig, treeCatalogueSelectConfig, productLookedRecordConfig, loginConfig, registerConfig, detailConfig, addToCartConfig, getUserCartConfig, deleteCartItemsConfig, updateCartItemsConfig, createOrderFromCartConfig, queryUserOrderListConfig, createOrderFromProductConfig, queryUserShippingListConfig, shippingInfoConfig, shippingInfodetailConfig, shippingInfoupdateConfig, shippingInfodeleteConfig, orderPrePayConfig, deleteOrderConfig, queryOrderDetailConfig, cancelOrderConfig, confirmConfig, queryOrderStatusConfig, batchAddToCartConfig, queryUserConfig, getUserOrderStatusCountConfig, updateEmailConfig, modifyPasswordConfig, resetPasswordConfig, sendSmsCodeConfig };
